import { Dispatch } from 'redux';
import * as actionTypes from './actionTypes';
import {
  Action,
  CustomEvent,
  CustomEventsErrorAction,
  CustomEventsRequestAction,
  CustomEventsResponseAction,
  DeletionPolicyUpdate,
  FetchDeletionPoliciesResponseAction,
  RetentionPeriodsByEventName,
  UpdateDeletionPoliciesAction,
} from './types';

// Custom Events
export const fetchCustomEventsRequest = (
  queryString: string,
  dispatch: Dispatch<any>,
): CustomEventsRequestAction => ({
  type: actionTypes.FETCH_CUSTOM_EVENTS_REQUEST,
  queryString,
  dispatch,
});

export const fetchCustomEventsError = (error: string): CustomEventsErrorAction => ({
  type: actionTypes.FETCH_CUSTOM_EVENTS_ERROR,
  error,
});
export const fetchCustomEventsResponse = (
  customEvents: CustomEvent[],
): CustomEventsResponseAction => ({
  type: actionTypes.FETCH_CUSTOM_EVENTS_RESPONSE,
  customEvents,
});

export const fetchDeletionPoliciesRequest = (): Action => ({
  type: actionTypes.FETCH_DELETION_POLICIES_BY_PROJECT_REQUEST,
});

export const fetchDeletionPoliciesByProjectResponse = (
  retentionPeriodsByEventName: RetentionPeriodsByEventName,
): FetchDeletionPoliciesResponseAction => ({
  type: actionTypes.FETCH_DELETION_POLICIES_BY_PROJECT_RESPONSE,
  retentionPeriodsByEventName,
});

export const fetchDeletionPoliciesByProjectError = (error: string): CustomEventsErrorAction => ({
  type: actionTypes.FETCH_DELETION_POLICIES_BY_PROJECT_ERROR,
  error,
});

export const updateDeletionPoliciesRequest = (
  deletionPolicyUpdate: DeletionPolicyUpdate,
): UpdateDeletionPoliciesAction => ({
  type: actionTypes.UPDATE_DELETION_POLICIES_REQUEST,
  deletionPolicyUpdate,
});

export const updateDeletionPoliciesResponse = (): Action => ({
  type: actionTypes.UPDATE_DELETION_POLICIES_RESPONSE,
});

export const updateDeletionPoliciesError = (error: string): CustomEventsErrorAction => ({
  type: actionTypes.UPDATE_DELETION_POLICIES_ERROR,
  error,
});
